export default __webpack_public_path__ + "static/media/SEMILLAMAIZ_ZH.551f7f1b.jpg";